export const validateIntakeStep = (currentStepId, formData) => {
  const newErrors = {};

  switch (currentStepId) {
    case 'demographic':
      if (!formData?.preferredName?.trim()) {
        newErrors.preferredName = 'Preferred name is required';
      }
      if (!formData?.populationSegment) {
        newErrors.populationSegment = 'Please select your role';
      }
      break;

    case 'cultural':
      if (!formData?.languages || formData?.languages?.length === 0) {
        newErrors.languages = 'Please select at least one language';
      }
      break;

    case 'issues':
      if (!formData?.currentIssues || formData?.currentIssues?.length === 0) {
        newErrors.currentIssues = 'Please select at least one concern';
      }
      break;

    case 'severity':
      if (!formData?.urgencyLevel) {
        newErrors.urgencyLevel = 'Please select urgency level';
      }
      if (!formData?.impactLevel) {
        newErrors.impactLevel = 'Please select impact level';
      }
      break;

    case 'preferences':
      if (!formData?.helperType) {
        newErrors.helperType = 'Please select helper type preference';
      }
      if (!formData?.sessionFormats || formData?.sessionFormats?.length === 0) {
        newErrors.sessionFormats = 'Please select at least one session format';
      }
      break;

    case 'consent':
      if (!formData?.dataConsent?.matching) {
        newErrors.dataConsent = 'Matching consent is required to use the platform';
      }
      if (!formData?.agreeToTerms) {
        newErrors.agreeToTerms = 'You must agree to the terms to continue';
      }
      if (!formData?.understandLimitations) {
        newErrors.understandLimitations = 'Please acknowledge platform limitations';
      }
      break;

    default:
      break;
  }

  return newErrors;
};